import styled from "styled-components"
import constants from "utils/constants"
import { Link } from "react-router-dom"

export default function Reward({ rewardDescriptions }) {
	return (
		<ComponentWrapper>
			{Array.isArray(rewardDescriptions) &&
				rewardDescriptions.map((description) => {
					const keyName = `description-img-${description.filename}`
					const rewardDesc = []
					if (description.redirect_type === "external_link") {
						rewardDesc.push(
							<ExternalLink
								href={description.redirect_dest}
								target="_blank"
								key={keyName + "-link"}
							>
								<DescImg
									src={`${constants.imagePath}/motibell/reward_img/${description.filename}`}
								/>
							</ExternalLink>
						)
					} else if (description.redirect_type === "path") {
						rewardDesc.push(
							<PathLink to={description.redirect_dest} key={keyName + "-link"}>
								<DescImg
									src={`${constants.imagePath}/motibell/reward_img/${description.filename}`}
								/>
							</PathLink>
						)
					} else {
						rewardDesc.push(
							<DescImg
								src={`${constants.imagePath}/motibell/reward_img/${description.filename}`}
								key={keyName + "-img"}
							/>
						)
					}

					return <ImgWrapper key={keyName}>{rewardDesc}</ImgWrapper>
				})}
		</ComponentWrapper>
	)
}
const ComponentWrapper = styled.div``
const ImgWrapper = styled.div``
const DescImg = styled.img``
const ExternalLink = styled.a``
const PathLink = styled(Link)``
